/*       */

import { gql } from '@apollo/client';

export default gql`
    query loadEntityMediaQuery($type: String!, $id: ID!) {
        result: entity(type: $type, id: $id) {
            id
            media {
                mediaName
                fileId
                fileName
                fileSize
                mimeType
                uploadedBy {
                    type
                    id
                    name
                    image
                    username
                    active
                }
                uploadedDate
                etag
            }
        }
    }
`;
